module.exports = __webpack_public_path__ + "static/media/Mapa-Roraima.71b2e01d.svg";